module.exports = __webpack_public_path__ + "static/media/045.c7409aa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/045.jpg
// module id = 390
// module chunks = 0